import { create } from "zustand";

export const useStoreCoachBotsGet = create((set, get) => ({
  coachBots: [],
  getCoachBotApiResponse: {},
  activeBotId: null,
  isCallInProgress: false,

  setCoachBots: (data) =>
    set((state) => {
      const bots = Array.isArray(data?.data)
        ? [...data.data].sort((a, b) => {
            const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
            const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
            return bTime - aTime;
          })
        : [];
      const existingActive = state.activeBotId;
      const isExistingActiveValid = bots.some((bot) => bot?.id === existingActive);
      const activeBotId = isExistingActiveValid
        ? existingActive
        : bots.length
        ? bots[0]?.id ?? null
        : null;

      return {
        coachBots: bots,
        getCoachBotApiResponse: data,
        activeBotId,
      };
    }),

  setActiveBot: (botId) =>
    set((state) => {
      if (state.isCallInProgress) {
        return state;
      }
      return { activeBotId: botId };
    }),

  setCallInProgress: (inProgress) =>
    set((state) =>
      state.isCallInProgress === inProgress ? state : { isCallInProgress: inProgress }
    ),
}));
